import {
    Shirt,
    Sparkles,
    Droplets,
    Truck,
    Clock,
    Shield,
    Wifi,
    Tv,
    CreditCard,
    Car,
  } from "lucide-react";

  import testimonialOne  from '@/assets/testimonial-1-female.jpeg'
  import testimonialTwo  from '@/assets/testimonial-2-male.jpeg'
  import testimonialThree  from '@/assets/testimonial-3-female.jpeg'
  import award2014 from '@/assets/2014.jpg'
  import award2015 from '@/assets/2015.jpg'
  import award2016 from '@/assets/2016.jpg'
  import award2017 from '@/assets/2017.jpg'
  import award2018 from '@/assets/2018.jpg'
  import award2019 from '@/assets/2019.jpg'
  import award2020 from '@/assets/2020.jpg'
  import award2021 from '@/assets/2021.png'
  import award2023 from '@/assets/2023.jpg'
  import award2024 from '@/assets/2024.jpg'

const HomePage = {
    services: [
        {
            icon: Shirt,
            title: "Wash & Fold",
            description: "Professional cleaning at $2.59/lb",
            price: "$2.59/lb",
            link: "/services#wash-fold",
        },
        {
            icon: Sparkles,
            title: "Dry Cleaning",
            description: "Eco-friendly and fast service",
            price: "Ask us",
            link: "/services#dry-cleaning",
        },
        {
            icon: Droplets,
            title: "Fresh Gear",
            description: "Ozone sanitization for sports equipment",
            price: "Ask us",
            link: "/services#fresh-gear",
            highlight: true,
        },
        {
            icon: Truck,
            title: "Pickup & Delivery",
            description: "We come to you within 25km",
            price: "Free*",
            link: "/booking",
        }
    ],
    features: [
        { icon: Wifi, text: "Free WiFi" },
        { icon: Tv, text: "TV Lounge" },
        { icon: CreditCard, text: "Change Machine" },
        { icon: Car, text: "Free Parking" },
        { icon: Clock, text: "6am - 11pm" },
        { icon: Shield, text: "Surveillance" }
    ],
     testimonials: [
    {
      name: "Sarah L.",
      text: "Outstanding service! They always deliver my clothes on time, perfectly cleaned and neatly pressed. The staff is friendly and professional.",
      rating: 5,
      image: testimonialOne,
    },
    {
      name: "John M.",
      text: "They removed stubborn stains from my favorite suit that I thought were impossible. Quick turnaround and reasonable pricing.",
      rating: 5,
      image: testimonialTwo,
    },
    {
      name: "Emily S.",
      text: "Loyal customer for years. The quality of cleaning is exceptional. Pickup and delivery is a game-changer for my busy schedule.",
      rating: 5,
      image: testimonialThree,
    },
  ],
  awards: [
    { year: "2014", image: award2014},
    { year: "2015", image: award2015 },
    { year: "2016", image: award2016},
    { year: "2017", image: award2017 },
    { year: "2018", image: award2018 },
    { year: "2019", image: award2019 },
    { year: "2020", image: award2020 },
  ]
}

const AwardPage = {
   awards: [
    { year: "2014", image: award2014},
    { year: "2015", image: award2015 },
    { year: "2016", image: award2016},
    { year: "2017", image: award2017 },
    { year: "2018", image: award2018 },
    { year: "2019", image: award2019 },
    { year: "2020", image: award2020 },
    { year: "2021", image: award2021 },
    { year: "2023", image: award2023 },
    { year: "2024", image: award2024 },
  ]
}

export const IconMap = {
  HomePage,
  AwardPage
};